import { Loader, Text, Tooltip } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import { useDesktopDatabaseSync } from "../../../router/hooks";
import { Flex } from "../../../styled";
import { useTheme } from "../../../hooks";

const SyncingLoader = () => {
  const theme = useTheme();
  const { isLoadingVisible, progress, syncStep, syncErrors, databaseHealth } =
    useDesktopDatabaseSync();

  const hasErrors = syncErrors.length > 0;
  const errorTooltip = hasErrors
    ? syncErrors.map(error => error.message).join("\n\n")
    : databaseHealth && !databaseHealth.ready
      ? (databaseHealth.reason ?? "Database is not ready")
      : undefined;

  if (!isLoadingVisible && !hasErrors) {
    return null;
  }

  return (
    <Tooltip
      label={errorTooltip ?? syncStep}
      multiline
      maw={420}
      disabled={!errorTooltip && !syncStep}>
      <Flex align="center" gap={5}>
        {isLoadingVisible ? (
          <>
            <Loader size="sm" color={theme.colors.main[2]} />
            <Text c={theme.colors.main[2]} size="sm">
              {`${progress}%`}
            </Text>
          </>
        ) : null}
        {hasErrors ? (
          <IconAlertTriangle size={16} color={theme.colors.red?.[5] ?? "red"} />
        ) : null}
      </Flex>
    </Tooltip>
  );
};

export default SyncingLoader;
